<div class="my-5">
  <sm-page-header 
    *ngIf="!companyId"
    [breadcrumb]="breadcrumb"
    title="settings.activity.title">
  </sm-page-header>
  <!-- content -->
  <div [ngClass]="{ content: !companyId }">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="activityDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="activityDialog"></sm-dialog>
</div>